import { GuestFlightScheduleLiteModel } from 'api-hooks/cro/model';
import * as Yup from 'yup';

const FlightScheduleDetailFormSchema = () =>
  Yup.object({
    id: Yup.string().default(''),
    checkInStatus: Yup.string().nullable().default(null),
    //additional information
    isCheck: Yup.boolean().default(false),
  });

export const FlightScheduleFormSchema = () =>
  Yup.object({
    flightSchedules: Yup.array(FlightScheduleDetailFormSchema()).default([]),
  });

export type FlightScheduleFormType = {
  flightSchedules: FlightScheduleDetailFormType[];
  data: GuestFlightScheduleLiteModel[];
};

export type FlightScheduleDetailFormType = GuestFlightScheduleLiteModel &
  Yup.InferType<ReturnType<typeof FlightScheduleDetailFormSchema>>;
